module.exports = __webpack_public_path__ + "static/media/ProjectInsight001.723775a7.png";